import { useState } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function PartnerRegister() {
  const [step, setStep] = useState(1)
  const [form, setForm] = useState({
    name: '', phone: '', password: '', promoType: 'personal', idCard: '', address: '', recommendCode: ''
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [result, setResult] = useState(null)
  const [referrerId, setReferrerId] = useState('')

  const promoTypes = [
    { value: 'personal', label: '个人推广员', color: '#13c2c2', fee: '免费注册', features: ['免费注册', 'AI动画类佣金30%', '线上课程佣金60%', '无系统权限', '不能招募下线'] },
    { value: 'certified', label: '认证推广员', color: '#722ed1', fee: '¥5,000/年', features: ['AI动画类佣金40%', '线上课程佣金80%', '完整系统权限', '推荐奖¥1,000/人', '招募认证/机构推广员', '管理奖(下线业绩)'] },
    { value: 'agency', label: '机构推广合伙人', color: '#fa8c16', fee: '¥5,000/年+SaaS', features: ['AI动画类佣金50%', '线上课程佣金80%', '完整系统权限', '线下活动利润100%', '推荐奖¥1,000/人', '招募认证/机构推广员'] }
  ]

  const currentType = promoTypes.find(t => t.value === form.promoType)

  // 根据推荐码查找推荐人
  const lookupReferrer = async (code) => {
    if (!code || code.length < 4) {
      setReferrerId('')
      return
    }
    try {
      const res = await fetch(`${API}/partners/lookup?code=${code}`)
      const d = await res.json()
      if (d.success && d.data) {
        setReferrerId(d.data.id)
      } else {
        setReferrerId('')
      }
    } catch (e) {
      setReferrerId('')
    }
  }

  const handleRecommendCodeChange = (value) => {
    setForm({ ...form, recommendCode: value })
    lookupReferrer(value)
  }

  const handleSubmit = async () => {
    if (!form.name.trim()) { alert('请输入姓名'); return }
    if (!form.phone || !/^1\d{10}$/.test(form.phone)) { alert('请输入正确的手机号'); return }
    if (!form.password || form.password.length < 6) { alert('请输入至少6位密码'); return }
    
    setLoading(true)
    try {
      const res = await fetch(`${API}/partners`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form, 
          password: form.password || '123456',
          referrer_id: referrerId
        })
      })
      const d = await res.json()
      if (d.success) {
        setResult(d.data)
        setSuccess(true)
      } else {
        alert(d.error || '注册失败')
      }
    } catch (e) {
      alert('注册失败')
    }
    setLoading(false)
  }

  if (success && result) {
    return (
      <div style={{ padding: 40, maxWidth: 600, margin: '0 auto' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 32, textAlign: 'center', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
          <h2 style={{ fontSize: 24, color: '#52c41a', marginBottom: 16 }}>恭喜！注册成功！</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>
            您已获得 <strong style={{ color: '#fa8c16', fontSize: 18 }}>7天免费推广体验期</strong>
          </p>
          
          <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 8, padding: 20, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontWeight: 600, marginBottom: 12, color: '#fa8c16' }}>🎁 您已获得（机构推广合伙人7天体验）：</div>
            <div style={{ display: 'grid', gap: 8, fontSize: 14, color: '#666' }}>
              <div>✅ <strong>80%</strong>最高佣金比例</div>
              <div>✅ 完整的推广系统权限</div>
              <div>✅ 推广链接生成功能</div>
              <div>✅ 下线管理功能</div>
              <div>✅ 佣金查看和提现</div>
              <div>✅ 线下活动利润100%</div>
              <div>✅ 招募下线奖励</div>
            </div>
          </div>
          
          <div style={{ background: '#f6ffed', borderRadius: 8, padding: 20, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontWeight: 600, marginBottom: 12 }}>您的推广信息：</div>
            <div style={{ display: 'grid', gap: 8, fontSize: 14 }}>
              <div>推广员ID：<strong>{result.id}</strong></div>
              <div>姓名：{result.name}</div>
              <div>等级：<strong style={{ color: '#fa8c16' }}>{result.level}</strong></div>
              <div>佣金比例：<strong style={{ color: '#52c41a' }}>{result.commission_rate}%</strong></div>
              <div>体验到期：{result.days_left || 7} 天后</div>
            </div>
          </div>

          <div style={{ background: '#fff1f0', borderRadius: 8, padding: 16, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontSize: 13, color: '#cf1322' }}>
              <strong>⏰ 重要提醒：</strong>
              <ul style={{ margin: '8px 0 0', paddingLeft: 20, lineHeight: 1.8 }}>
                <li>7天体验期结束后，如需继续使用请联系我们续费</li>
                <li>续费可享受优惠价格</li>
              </ul>
            </div>
          </div>

          <button onClick={() => window.close()} style={{ padding: '12px 32px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
            完成
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={{ paddingTop: 80, padding: 40 }}>
      {/* 顶部功能栏 */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',background:'#1890ff',color:'#fff',marginBottom:16,borderRadius:8,position:'sticky',top:0,zIndex:100}}>
        <button onClick={()=>window.history.back()} style={{padding:'8px 16px',background:'rgba(255,255,255,0.2)',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',fontSize:13,position:'relative',zIndex:101}}>← 返回</button>
        <span style={{fontSize:13}}>邀请他人申请</span>
        <button onClick={()=>{var l=window.location.origin+'/?page=partner-register';navigator.clipboard.writeText(l).then(()=>alert('已复制!')).catch(()=>prompt('复制:',l))}} style={{padding:'8px 16px',background:'#fff',color:'#1890ff',border:'none',borderRadius:6,cursor:'pointer',fontWeight:600,fontSize:13}}>复制链接</button>
      </div>

      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h2 style={{ fontSize: 24, marginBottom: 8 }}>推广员注册</h2>
          <p style={{ color: '#666' }}>成为博小兔推广员，开启轻创业之旅</p>
        </div>

        {/* 步骤指示器 */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
          {[1, 2].map(s => (
            <div key={s} style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{
                width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: step >= s ? '#1890ff' : '#f0f0f0', color: step >= s ? '#fff' : '#999', fontWeight: 600
              }}>
                {s}
              </div>
              {s < 2 && <div style={{ width: 60, height: 2, background: step > s ? '#1890ff' : '#f0f0f0' }} />}
            </div>
          ))}
        </div>

        {step === 1 ? (
          <div style={{ background: '#fff', borderRadius: 16, padding: 24 }}>
            <h3 style={{ marginBottom: 16 }}>选择推广类型</h3>
            <div style={{ display: 'grid', gap: 12, marginBottom: 24 }}>
              {promoTypes.map(t => (
                <div
                  key={t.value}
                  onClick={() => setForm({ ...form, promoType: t.value })}
                  style={{
                    padding: 16, border: '2px solid', borderColor: form.promoType === t.value ? t.color : '#e8e8e8',
                    background: form.promoType === t.value ? `${t.color}11` : '#fff',
                    borderRadius: 12, cursor: 'pointer'
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontWeight: 600, color: form.promoType === t.value ? t.color : '#333' }}>{t.label}</span>
                    <span style={{ fontSize: 12, color: '#fa8c16', fontWeight: 600 }}>{t.fee}</span>
                  </div>
                  <div style={{ fontSize: 12, color: '#666', lineHeight: 1.6 }}>
                    {t.features.map((f, i) => <span key={i}>• {f} &nbsp;</span>)}
                  </div>
                </div>
              ))}
            </div>
            <button onClick={() => setStep(2)} style={{ width: '100%', padding: 14, background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
              下一步：填写信息
            </button>
          </div>
        ) : (
          <div style={{ background: '#fff', borderRadius: 16, padding: 24 }}>
            <h3 style={{ marginBottom: 16 }}>填写基本信息</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={label}>姓名 *</label>
              <input type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="请输入真实姓名" style={input} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>手机号 *</label>
              <input type="tel" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="请输入手机号" maxLength={11} style={input} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>登录密码 *</label>
              <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="请设置登录密码（至少6位）" style={input} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>身份证号（选填）</label>
              <input type="text" value={form.idCard} onChange={e => setForm({ ...form, idCard: e.target.value })} placeholder="选填，用于实名认证" style={input} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>地址（选填）</label>
              <input type="text" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} placeholder="选填" style={input} />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={label}>推荐码（选填）{referrerId && <span style={{color: '#52c41a', marginLeft: 8}}>✓ 已找到推荐人</span>}</label>
              <input type="text" value={form.recommendCode} onChange={e => handleRecommendCodeChange(e.target.value)} placeholder="如有推荐人请填写推荐码" style={input} />
              <div style={{fontSize: 11, color: '#999', marginTop: 4}}>推荐人注册后获得的推荐码</div>
            </div>

            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={() => setStep(1)} style={{ flex: 1, padding: 14, background: '#f5f5f5', color: '#666', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
                上一步
              </button>
              <button onClick={handleSubmit} disabled={loading} style={{ flex: 2, padding: 14, background: loading ? '#d9d9d9' : '#52c41a', color: '#fff', border: 'none', borderRadius: 8, cursor: loading ? 'not-allowed' : 'pointer', fontSize: 16 }}>
                {loading ? '提交中...' : '提交注册'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const label = { display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }
const input = { width: '100%', padding: '12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }
